<script>
  export let content;
</script>


<div class="relative flex group-tooltip">
  <slot></slot>
  <div class="bottom-full left-1/2 -translate-x-2/4 mb-3 transition-none duration-200 ease-out text-gray-800 rounded shadow-lg bg-white border-2 font-medium absolute transform z-50 flex items-center justify-center invisible opacity-0 group-tooltip-hover:visible group-tooltip-hover:opacity-100 group-tooltip-hover:transition-opacity">
    <div class="text-center p-2 font-sans font-normal text-sm w-max">
      {content}
    </div>
    <!-- Arrow -->
    <div class="bottom-0 -mb-2 h-2 w-7 justify-center items-end pb-1 flex overflow-hidden absolute">
      <div class="mt-1 transform rotate-45 bg-white h-5 w-5 border-2"></div>
    </div>
  </div>
</div>